import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { BlocksIcon } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { useGrid } from '@/components/Grid';
import { getInfo } from '@/components/Grid/components/Table/formatters';

export default function EditBuilderEntity({ info }) {
  const { row } = getInfo(info)
  const { definitions: { basePath, entityNameModule, entityNamePlural } } = useGrid()

  const path = useMemo(() => {
    if (basePath) return basePath;
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNameModule, entityNamePlural])

  return <>
    <DefaultTooltip content='DnD Builder'>
      <Link to={`${path}/${row.id}/builder`}>
        <BlocksIcon size={16} />
      </Link>
    </DefaultTooltip>
  </>
}
